import React from "react"
import docIcon from '../../pageComponents/images/doc-icon-mobile.svg'
import frecciaBlu from '../../pageComponents/images/freccia-blu-obliqua.svg'

const Page4Mobile = ({ backgroundColor, openPercent, color, innerRef }) => {
  return (
    <div ref={innerRef} style={{ background: backgroundColor, color: color }} className="grid-cols-4 md:grid-cols-8">
      <div className='col-4 md:col-6 md:col-offset-left-1'>
        <div className='mt-5 barra-arancio'></div>
        <div className='mt-5 font-20 line-height-26'>
          Nuovi interessanti sviluppi al mercato della mobilità elettrica in
          Italia arriveranno dalla diffusione dell’integrazione tra veicoli e
          rete elettrica, il cosiddetto vehicle to grid (V2G). La legislazione converge verso
          iniziative che comportano la diffusione di impianti fotovoltaici per l’alimentazione
          del punto di ricarica dei veicoli elettrici (decreto 4 Luglio 2019) e progetti
          innovativi di accesso al mercato dei servizi di dispacciamento (MSD) per
          le batterie dei veicoli elettrici.
        </div>
        <div className='mt-2 font-20 line-height-26'>
          La stessa Commissione Europea ha previsto l’introduzione di una quota
          minima annua di veicoli elettrici per tutti i produttori automobilistici
          europei; nel continente, inoltre, entro la fine del 2020, saranno
          installati più di quattro milioni di punti di ricarica per la mobilità
          elettrica. Il boom di questi mezzi si intreccia poi con la
          liberalizzazione del mercato europeo dell’energia.
        </div>
        <div className='mt-2 font-20 line-height-26'>
          Fuori dall’Unione Europea, troviamo l’accordo siglato da almeno otto
          Stati americani, che prevede di avere in circolazione 3.5 milioni di
          veicoli a emissioni zero entro il 2025. Sul versante orientale invece,
          l’India introdurrà divieti analoghi entro il 2030, e la Cina – che con
          28 milioni di nuove automobili all’anno è la principale produttrice mondiale
          (più di Stati Uniti, Giappone e Germania messi insieme) – sta discutendo
          di imporre un limite.
        </div>
        <div className='mt-5 col-spread-gutter'>
          <div className='text-center pb-6 col-inset-gutter' style={{ backgroundColor: '#005BBB', borderRadius: 20 }}>
            <div className='mt-3'>
              <img src={docIcon} alt='Doc Icon' />
            </div>
            <div className='mt-3 font-16 line-height-20 text-white'>
              SETTEMBRE 2019
              </div>
            <div className='mt-3 text-left font-family-acumin font-weight-500 line-height-26 text-white'>
              L'accordo siglato tra Nissan e il Gruppo EDF consentirà di
              accelerare la crescita della mobilità elettrica nel Regno Unito,
              in Francia, Belgio e Italia, promuovendo soluzioni di ricarica
              intelligenti anche in logica V2G.
            </div>
            <div className='mt-4 xs:text-left'>
              <div className='md:mx-auto button-external-mobile align-items-center d-flex pl-1 pr-1 cursor-pointer'>
                <a className="basic-link" href="/PR_Nissan and EDF Group partners to accelerate Electric Vehicle adoption across Europe_EN certified.pdf" target="_blank" rel="noopener noreferrer">Leggi il comunicato</a>
                <img className='ml-1' src={frecciaBlu} alt='Freccia blu' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Page4Mobile
